
import React, {Component} from "react";
import style from "./style.scss";
// import {Input} from "antd";
import CurrentUserDropDownMenu from "../CurrentUserDropDownMenu";
import VisionMode from "../VisionMode";
import {AppLayoutSideBarMenuIcon} from "../Layout";
import { Link } from 'react-router-dom';

/**
 * Header that displays the nbc logo and contains a dropdown menu.
 */
export default class AppHeader extends Component {

    // COMPONENT Render ................................
    render() {
        return (
            <div className={style.appHeader}>
                <div className={style.section}>
                    <AppLayoutSideBarMenuIcon onClick={() => {
                        this.props.onClickToggleLeftSideBar();
                    }}/>
                </div>

               <Link to="/"><div className={style.section}>
                    <img className={style.brandLogo} src={require('../../../Assets/peacock-day.jpg')} alt={'brand logo'}
                         height={40}/>
                    <img className={style.brandLogoNightMode} src={require('../../../Assets/peacock-trans.png')}
                         alt={'brand logo'}
                         height={40}/><h3 style={{ verticalAlign: "bottom", fontSize: 24, marginBottom: "-5%", marginLeft: "-5%"}}>STORM</h3>

                </div></Link>

                <div className={style.section} style={{ marginLeft: "-5%" }}>
                    <VisionMode/>
                    <CurrentUserDropDownMenu/>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Components/Theme/AppHeader/index.js